import { axiosPost, axiosPut } from 'shared/api/axios'
import { AxiosError } from 'axios'
import { apiUrls } from 'consts'
import displayGenError from 'shared/utils/displayGenError'
import setFormValidationError from 'shared/utils/setFormValidationError'

interface submitFormProps {
  data: any
  setShowOverlay: Function
  id: string | undefined
  setError: Function
}

const submitForm = async (props: submitFormProps) => {
  let response: any = false

  const formData = {
    ...props.data,
  }
  
  if (formData.active === false) {
    formData.active = 0  
  }

  const catchFunc = (err: AxiosError) => {
    if (err.response!.status === 422) {
      const mappedAttributes: Map<string, string> = new Map()
      mappedAttributes.set('vslz_id', 'vslz_id')
      mappedAttributes.set('display_name', 'display_name')
      mappedAttributes.set('home_url', 'home_url')
      mappedAttributes.set('ais_security_string', 'ais_security_string')
      setFormValidationError(err, props.setError, mappedAttributes, 'name')
    } else {
      displayGenError({ setShowOverlay: props.setShowOverlay })
    }
  }

  if (props.id === undefined) {
    response = await axiosPost(apiUrls.customers, formData, catchFunc)
  } else {
    response = await axiosPut(apiUrls.customers + '/' + props.id, formData, catchFunc)
  }
  return response
}

export default submitForm
